import { useMutation, useQuery, useQueryClient } from "react-query";
import useApiHelper from "../services/useApiHelper";

export default function useSocialScheduleMutations() {
  const staleTime = 1000 * 60;
  const queryClient = useQueryClient();
  const { get, post, put, del } = useApiHelper();

  const addEmptyPost = useMutation(
    (scheduleId) => put(`/socialSchedule/${scheduleId}/emptypostdata`, null),
    {
      onSuccess: () => {
        queryClient.refetchQueries(["socialSchedules"])
      },
    }
  );

  const removeSchedule = useMutation(
    (scheduleId) => del(`/socialSchedule/${scheduleId}`),
    {
      onSuccess: (_, scheduleId) => {
        queryClient.refetchQueries(["socialSchedules"])
      },
    }
  );

  const updatePost = useMutation(
    (postData) => put(`/socialSchedule/postdata`, postData),
    {
      onSuccess: () => {
        queryClient.refetchQueries(["socialSchedules"])
      },
    }
  );


  const removePost = useMutation(
    (ids) => del(`/socialSchedule/postdata/${ids.scheduleId}/${ids.postId}`),
    {
      onSuccess: (_, scheduleId) => {
        queryClient.refetchQueries(["socialSchedules"])
      },
    }
  );

  const updateToggles = useMutation(
    (postData) => put(`/socialSchedule/postdata/allToggles`, postData),
    {
      onSuccess: () => {
        queryClient.refetchQueries(["socialSchedules"])
      },
    }
  );


  return {
    addEmptyPost,
    removeSchedule,
    updatePost,
    removePost,
    updateToggles
  };
}
